import { configureStore, createListenerMiddleware } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import { persistReducer } from 'redux-persist';
import localForage from 'localforage';
import { listenerMiddleware } from 'shared/interface/sharedJsInterface';

import { immutablePersistenceTransform, BugfenderLogger, loading } from 'helpers/sharedJsHelpers';


import rootReducer from 'reducers/rootReducer';


const { bugfenderReduxLogger, bugfenderReduxExceptionReporter } = BugfenderLogger;
const { loadingMiddleware } = loading;


// TODO: Add listeners here if needed in the future

export default function makeStore(persist = false) {
  const middleware = [loadingMiddleware, bugfenderReduxLogger, bugfenderReduxExceptionReporter];
  if (window?.enableReduxConsoleLogging) {
    middleware.push(
      createLogger({
        diff: true,
        collapsed: true, // collapsed can also be a function (getState, action) if we want certain actions to be open
        predicate: (getState, action) => action.type !== 'QUIZ_TICK',
        diffPredicate: (getState, action) => !['STATIC_DATA_FETCHED', 'PERFORMANCE_RESPONSES_FETCHED', 'PERFORMANCE_QUESTIONS_FETCHED', 'QUIZZES_FETCHED'].includes(action.type),
        stateTransformer(state) {
          const stateLog = {};
          // We want to make sure to output any ImmutableJS objects here as plain JS objects
          Object.keys(state).forEach((key) => {
            if (['modal', 'performanceResponses', 'performanceQuestions', 'performancePeers', 'performanceAllStudents', 'performanceSchoolPeers'].includes(key)) return;

            const value = state[key];
            if (typeof value.toJS === 'function') {
              stateLog[key] = value.toJS();
            } else {
              stateLog[key] = value;
            }
          });
          return stateLog;
        }
      })
    );
  }

  const persistConfig = {
    transforms: [immutablePersistenceTransform],
    key: 'root',
    storage: localForage,
    blacklist: ['loading', 'modal']
  };

  const reducer = persist ? persistReducer(persistConfig, rootReducer) : rootReducer;

  const store = configureStore({
    reducer,
    middleware: getDefaultMiddleware => [
      ...getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: true,
      }).prepend(listenerMiddleware.middleware),
      ...middleware
    ]
  });
  return store;
}
